<template>
  <div class="edit standing customerServiceEdit">
    <div class="standing-bar">
      <el-row>
        <el-button type="primary" size="small" icon="el-hg-icon-edit" :disabled="buttonStart(1)"
                   @click="editStart = false">修改
        </el-button>
        <el-button type="primary" size="small" icon="el-hg-icon-edit" :disabled="buttonStart(2)" @click="checkForm">保存
        </el-button>
        <el-button type="primary" size="small" icon="el-hg-icon-audit" @click="btnConfirm(doAudit,'是否审核选中提单？')"

                   :disabled="buttonStart(3)">审核
        </el-button>
        <el-button type="danger" size="small" icon="el-hg-icon-delete"
                   @click="btnConfirm(operationDeleteEven,'确认作废此提单？')"

                   :disabled="buttonStart(6)">作废
        </el-button>
        <el-button type="danger" size="small" @click.native=" btnConfirm(operationRevokeEven,'是否退审选中提单？')"
                   icon="el-icon-remove"
                   :disabled="buttonStart(7)"> 退审
        </el-button>
        <!--<el-button type="primary" size="small" icon="el-icon-back" @click="doCancleAudit" :disabled="buttonStart(3)">退审</el-button>-->
        <!--<el-button type="primary" size="small" icon="el-icon-circle-check" @click="doFinish" :disabled="buttonStart(4)">完成</el-button>-->
        <el-button type="primary" size="small" icon="el-hg-icon-refreash" @click="detail(id)"
                   :disabled="buttonStart(4)">刷新
        </el-button>
        <!--<el-button type="primary" size="small" icon="el-hg-icon-downloadf" :disabled="buttonStart(5)">导出</el-button>-->
        <el-button type="primary" size="small" icon="el-icon-paperclip" @click="enclosureStart = !enclosureStart">附件
        </el-button>
        <el-button type="primary" size="small" icon="el-icon-paperclip"
                   :disabled="!buttonStart(2)"
                   @click="pasteOrder">复制提单
        </el-button>
      </el-row>
    </div>
    <div :class="[editStart ? 'edit_modle': 'edit_modle editStart']" :style="{height: editModleHeight + 'px'}">
      <div class="edit_from" ref="edit_from">
        <el-form ref="topForm" :model="formInline" :rules="rules" class="top-form" label-width="110px" size="mini">
          <el-form-item v-for="(itme, key) in fromList" :prop="itme.key" :key="key"
                        :style="{width:itme.width?itme.width:''}" :class="{'halfItem':itme.width}">
            <span slot="label" v-if="!itme.isNoShow">
              <span v-if="itme.must"><span style="color: red">*</span>{{itme.label}}</span>
              <span v-else>{{itme.label}}</span>
            </span>
            <div v-if="!itme.isNoShow">
              <el-input v-if="itme.type === 'input'" v-model="formInline[itme.key]" placeholder="请输入内容"
                        :type="itme.contentType==='number'?'number':'text'" clearable
                        :class="[itme.contentType==='number'?'alignRight':'']"
                        :disabled="itme.disabled" @change="inputChangeEven(itme.key)"/>
              <el-input v-if="itme.type === 'inputButton'" v-model="formInline[itme.key]" placeholder="请输入内容" clearable
                        :type="itme.contentType==='number'?'number':'text'"
                        :disabled="itme.disabled" @change="inputChangeEven(itme.key)">
                <el-button slot="append" v-if="itme.tips !== '列批号'" @click="openDialog(itme.dialog, null, itme.code)"
                           icon="el-icon-more" :disabled="editStart"></el-button>
                <template slot="append" v-else>
                  <p style="cursor: pointer; text-align: center;" @click="openDialog(itme.dialog, null, itme.code)">
                    {{itme.tips}}</p>
                </template>
              </el-input>
              <el-switch
                v-if="itme.type==='switch'"
                :disabled="editStart"
                v-model="formInline[itme.key]"
                active-color="#13ce66">
              </el-switch>
              <el-select v-if="itme.type === 'select'" filterable v-model="formInline[itme.key]" allow-create
                         placeholder="请输入内容" :disabled="editStart">
                <el-option
                  v-for="(value, key) in itme.list"
                  :key="key"
                  :label="value[itme.labelName]"
                  :value="value[itme.value]">
                </el-option>
              </el-select>
              <el-autocomplete
                v-if="itme.type === 'inputCustom'"
                :disabled="editStart"
                v-model="formInline[itme.key]"
                :fetch-suggestions="querySearch"
                placeholder="请输入内容"
                @select="inputSelectEven">
                <template slot-scope="{ item }">
                  <div class="name">{{ item.BLNO }}</div>
                </template>
              </el-autocomplete>
              <el-date-picker
                @change="datePickerEven(itme.key)"
                :disabled="editStart"
                v-if="itme.type === 'datePicker'"
                v-model="formInline[itme.key]"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期"></el-date-picker>
              <!--:picker-options="pickerOptionsEnd(itme.key)"-->
            </div>
          </el-form-item>
        </el-form>
        <el-row :gutter="4" v-if="$route.name === 'billLadingShip' || $route.name === 'addBillLadingShip'">
          <el-col :span="12">
            <el-form label-position="right" label-width="90px" size="mini">
              <el-form-item label="特殊要求" class="redTextarea">
                <el-input
                  :disabled="editStart"
                  type="textarea"
                  :rows="3"
                  placeholder="请输入内容"
                  v-model="formInline.SpecialRequest"></el-input>
              </el-form-item>
            </el-form>
          </el-col>
          <el-col :span="12">
            <el-form label-position="right" label-width="90px" size="mini">
              <el-form-item label="备注">
                <el-input v-model="formInline.Remark" type="textarea"
                          :rows="3" placeholder="请输入内容" :disabled="editStart"></el-input>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
        <el-row :gutter="4"
                v-else-if="$route.name === 'billLadingUnloadShip' || $route.name === 'addBillLadingUnloadShip'">
          <el-col :span="12">
            <el-form label-position="right" label-width="90px" size="mini">
              <el-form-item label="特殊要求" class="redTextarea">
                <el-input
                  :disabled="editStart"
                  type="textarea"
                  :rows="2"
                  placeholder="请输入内容"
                  v-model="formInline.SpecialRequest"></el-input>
              </el-form-item>
            </el-form>
          </el-col>
          <el-col :span="12">
            <el-form label-position="right" label-width="90px" size="mini">
              <el-form-item label="备注">
                <el-input v-model="formInline.Remark" type="textarea"
                          :rows="2" placeholder="请输入内容" :disabled="editStart"></el-input>
              </el-form-item>
            </el-form>
          </el-col>

        </el-row>
      </div>
      <div class="edit_table" ref="edit_table">
        <div class="tableCon">
          <div class="tableContent-title">批号信息</div>
          <div class="tableContent">
            <div class="tableContent-pane">
              <div class="edit_header">
                <el-tooltip class="item" effect="dark" content="新增" placement="bottom">
                  <el-button size="small" type="primary" icon="el-icon-plus" @click="addNewBatchNumberData"
                             :disabled="editStart"></el-button>
                </el-tooltip>
                <!--<el-button size="small" type="primary" icon="el-icon-edit" ></el-button>-->
                <el-tooltip class="item" effect="dark" content="删除" placement="bottom">
                  <el-button size="small" type="primary" icon="el-icon-delete" @click="batchNumberDelete"
                             :disabled="editStart"></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="刷新列表" placement="bottom">
                  <el-button size="small" type="primary" icon="el-icon-refresh" @click="batchdetail(id)"
                             :disabled="editStart"></el-button>
                </el-tooltip>
                <!--<el-button size="small" type="primary" icon="el-icon-upload" @click="complete" :disabled="editStart"></el-button>-->
              </div>
              <sp-table
                min-width="90%"
                ref="batchTable"
                :parentTableData.sync="batchFilterData"
                :parentCol.sync="batchNumberCol"
                :drag-drop='true'
                @addNewData="addNewBatchNumberData"
                @selection-change="batchNumberSelectionChange"
                :is-edit="!editStart"
                class="batchTable"
              >
                <el-table-column align="center" type="selection" class="selection"></el-table-column>
                <el-table-column align="center" label="序号" type="index" width="50"/>
                <sp-table-column :align="item.titleAlignment" v-for="(item, index) in batchNumberCol" :key="index"
                                 :width="item.width">
                  <template slot="header">
                    <p><b style="color: red" v-if="!item.isNull">*</b>
                      {{item.title}}</p>
                  </template>
                  <template v-slot="{ scope }">
                    <div class="auto-input" v-if="!item.readOnly">
                      <div align="center" v-if="carOrderBatchComponent.checked.indexOf(item.field) > -1">
                        <el-checkbox v-model="scope.row[batchNumberCol[index].field]" :true-label=1
                                     :false-label=0></el-checkbox>
                      </div>
                      <div v-else-if="carOrderBatchComponent.inputButton.indexOf(item.field) > -1">
                        <el-input size="mini" v-model="scope.row[batchNumberCol[index].field]" placeholder="请输入内容">
                          <el-button slot="append"
                                     @click="openDialog(batchNumberCol[index].dialog, scope,null,batchNumberList)"
                                     icon="el-icon-more"></el-button>
                          <!--<template slot="append">-->
                          <!--<p style="cursor: pointer; text-align: center;" @click="openDialog(batchNumberCol[index].dialog, scope.$index)">-->
                          <!--{{batchNumberCol[index].tips}}</p>-->
                          <!--</template>-->
                        </el-input>
                      </div>
                      <div v-else>
                        <el-input size="mini" :type="[3,6,8].indexOf(item.fieldType) >=0?'number':''"
                                  v-model="scope.row[batchNumberCol[index].field]" placeholder="请输入内容"></el-input>
                      </div>
                    </div>
                    <div :class="[item.readOnly ? 'span spanEdit' : 'span']">
                      <div align="center" v-if="carOrderBatchComponent.checked.indexOf(item.field) > -1">
                        <el-checkbox v-model="scope.row[batchNumberCol[index].field]" :disabled="true" :true-label=1
                                     :false-label=0></el-checkbox>
                      </div>
                      <p v-else :align="item.alignment">{{scope.row[batchNumberCol[index].field]}}</p>
                    </div>
                  </template>
                </sp-table-column>
              </sp-table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- grid-dialog参数说明
         show：弹窗是否展示
         default-params：grid-dialog组件内部请求接口，传入组装好的数据内部请求接口
         default-values：由于接口返回值与传入接口参数的key不能完整对应，做的映射关系
         default-keys：如果需要搜索所获取对应的key
         ref-value: default-values映射到父级组建的值
         grid-config： 数据字典内容
         -->
    <grid-dialog :show="showGuestId"
                 title="客户选择"
                 :default-params="guestIdDefaultParams"
                 :default-values.sync="guestIdDefaultValue"
                 :default-keys="guestIdDefaultKeys"
                 :ref-value.sync="formInline"
                 :grid-config="guestIDByConditionsList"
                 :pageType="pageType"
                 @close="showGuestId = !showGuestId"></grid-dialog>
    <grid-dialog :show="showBargainID"
                 title="合同号选择"
                 :default-params="bargainIDDefaultParams"
                 :grid-config="dictionaryAction"
                 :pageType="pageType"
                 :default-values.sync="bargainDefaultValue"
                 :default-keys="bargainDefaultKeys"
                 :ref-value.sync="formInline"
                 @close="showBargainID = !showBargainID"></grid-dialog>
    <grid-dialog :show="showGoodsID"
                 title="产品选择"
                 :default-params="refGoodsDefaultParams"
                 :grid-config="refGoodsByConditionsList"
                 :default-values.sync="goodsDefaultValue"
                 :pageType="pageType"
                 :default-keys="goodsDefaultKeys"
                 :ref-value.sync="formInline"
                 @close="showGoodsID = !showGoodsID"></grid-dialog>
    <grid-dialog :show="showShipID"
                 title="船名选择"
                 :default-params="shipIdDefaultParams"
                 :grid-config="shipDicList"
                 :default-values.sync="shipDefaultValue"
                 :pageType="pageType"
                 :default-keys="shipDefaultKeys"
                 :ref-value.sync="formInline"
                 @close="showShipID = !showShipID"></grid-dialog>
    <grid-dialog :show="showshipSupplier"
                 title="船代选择"
                 :default-params="shipSupplierDefaultParams"
                 :grid-config="shipSupplierList"
                 :default-values.sync="shipSupplierDefaultValue"
                 :pageType="pageType"
                 :default-keys="shipSupplierKeys"
                 :ref-value.sync="formInline"
                 @close="showshipSupplier = !showshipSupplier"></grid-dialog>
    <grid-dialog :show="showgoodsSupplier"
                 title="货代选择"
                 :default-params="goodsSupplierDefaultParams"
                 :grid-config="shipSupplierList"
                 :default-values.sync="goodsSupplierDefaultValue"
                 :pageType="pageType"
                 :default-keys="goodsSupplierKeys"
                 :ref-value.sync="formInline"
                 @close="showgoodsSupplier = !showgoodsSupplier"></grid-dialog>
    <grid-dialog :show="showgetTGuest"
                 title="提货人"
                 :default-params="TGuestIDDefaultParams"
                 :grid-config="TGuestIDByConditions"
                 :pageType="pageType"
                 :default-values.sync="TGuestIDDefaultValue"
                 :default-keys="TGuestIDDefaultKey"
                 :ref-value.sync="formInline"
                 @close="showgetTGuest = !showgetTGuest"></grid-dialog>
    <grid-dialog :show="showTankID"
                 title="罐号选择"
                 :default-params="TankIDDefaultParams"
                 :grid-config="TankIDByConditions"
                 :default-values.sync="TankIDDefaultValue"
                 :addData.sync="addNewBatchNumberData"
                 :pageType="pageType"
                 :default-keys="TankIDDefaultKey"
                 :ref-list.sync="batchNumberList" :ref-list-index.sync="currentTank"
                 @close="showTankID = !showTankID"></grid-dialog>
    <grid-dialog :show="showAttachBargain"
                 title="地点"
                 :default-params="AttachBargainDefaultParams"
                 :grid-config="bargainIDByConditionsList"
                 :default-values.sync="AttachBargainDefaultValue"
                 :default-keys="AttachBargainDefaultKey"
                 :ref-value.sync="formInline"
                 @close="showAttachBargain = !showAttachBargain">
    </grid-dialog>
    <Dialog title="附件" :width="600" :height="400" :visible="enclosureStart" @close="enclosureStart = !enclosureStart">
      <div class="grid-contain dialog edit">
        <div style="margin-bottom: 20px" v-if="buttonStart(10)">
          <el-button type="primary" size="small" icon="el-icon-upload2" @click="uploadFileDesc = !uploadFileDesc">上传文件
          </el-button>
        </div>
        <div class="grid-table">
          <sp-table
            ref="batchTable"
            :parentTableData.sync="annexDetailList"
            :parentCol.sync="enclosureAction">
            <el-table-column align="center" type="selection" class="selection"></el-table-column>
            <el-table-column align="center" label="序号" type="index" width="50"/>
            <sp-table-column v-for="(item, index) in enclosureAction" :key="index" :width="item.width">
              <template slot="header">
                <p>{{item.title}}</p>
              </template>
              <template v-slot="{ scope }">
                <div class="span" v-if="item.field !== 'edit'">
                  <p>{{scope.row[enclosureAction[index].field]}}</p>
                </div>
                <div class="span" v-else>
                  <el-button type="primary" size="small" @click="fileDownload(scope.row)">下载</el-button>
                  <el-button type="danger" size="small" @click="fileDelete(scope.row)">删除</el-button>
                  <!--<el-button type="primary" size="small">删除</el-button>-->
                </div>
              </template>
            </sp-table-column>
          </sp-table>
        </div>
      </div>
    </Dialog>
    <Dialog title="上传文件说明" :width="400" :height="100" :visible="uploadFileDesc"
            @close="uploadFileDesc = !uploadFileDesc">
      <div class="grid-contain dialog edit">
        <el-form label-width="80px">
          <el-form-item label="文件说明">
            <el-input v-model="desc" placeholder="请输入说明后再选择文件"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" style="width:100%;text-align: right;display: flex;justify-content:center;">
          <el-upload
            class="upload-demo"
            action=""
            name="file"
            :show-file-list="false"
            :http-request="beforeAvatarUpload">
            <el-button size="small" :disabled="!desc" icon="el-hg-icon-save" type="primary">选择文件</el-button>
          </el-upload>
          <el-button size="small" icon="el-hg-icon-close" type="danger" @click="uploadFileDesc = !uploadFileDesc"
                     style="margin-left: 20px">关 闭
          </el-button>
        </div>
      </div>
    </Dialog>
  </div>
</template>
<script>
  import {mapGetters, mapActions} from 'vuex';
  import {spTable, spTableColumn} from '@/components/sptable';
  import dayjs from 'dayjs';
  import gridDialog from '@/components/gridDialog';
  import Dialog from '@/components/dialog';
  import storageM from '@/storage';
  import {Loading} from 'element-ui';

  const storage = storageM['sessionStorage'];

  export default {
    name: 'edit',
    components: {
      spTable,
      spTableColumn,
      gridDialog,
      Dialog,
    },
    data() {
      return {
        editStart: true, // 判断页面是否是编辑状态，所有可输入框是根据该字段判定
        addStart: true,
        id: '', // 订单唯一id
        type: '', // 页面入口进入不同，导致页面中的状态不同，根据状态判定页面页面是否可以编辑，是否添加，预览状态
        activeName: '批号信息',
        showGoodDic: false, // 弹窗绑定是否展示
        showGuestId: false,
        showBargainID: false,
        showGoodsID: false,
        showShipID: false,
        showshipSupplier: false,
        showgoodsSupplier: false,
        showgetTGuest: false,
        showLocation: false,
        showTankID: false,
        showAttachBargain: false,
        enclosureStart: false,
        uploadFileStart: false,
        uploadFileDesc: false,
        pageType: '',
        goodDIcDefaultParams: {
          type: 'BUSINESS',
          url: 'getGoods',
          params: {
            goodsId: '',
          },
        },
        batchNumberOriginData: {},
        licenseNumberOriginData: {},
        batchNumberList: [],
        licenseNumberList: [],
        bargainList: [],
        getRefGoodsList: [],
        guestIDList: [],
        getBlnoList: [],
        getBerthList: [],
        getBusinessDeptList: [],
        rules: {
          Name: [{
            required: true,
            message: '请选择客户',
            trigger: 'change'
          }],
          CEGoodsName: [{
            required: true,
            message: '请选择产品',
            trigger: 'change'
          }],
          BLNO: [{
            required: false,
            message: '请输入提单号',
            trigger: 'blur'
          }], BLNumber: [{
            required: true,
            message: '请输入提单数',
            trigger: 'blur'
          }], TGuestName: [{
            required: true,
            message: '请选择提货人',
            trigger: 'change'
          }], BargainID: [{
            required: true,
            message: '请选择合同号',
            trigger: 'change'
          }]
        },
        formInline: {
          ExtractSample: false,
          IsNon: false,
          Remark: '',
          SpecialRequest: '',
          OperatorID: '',
          CreateDate: '',
          Name: '',
          GuestID: '',
          CEGoodsName: '', // 产品名称
          GoodsID: '', // 产品id
          BLNumber: '', // 列单数
          BargainID: '', // 合同编号
          BillID: '', // 流水号
          Location: '',
          PreDate: `${this.$utils.getTimeByDay(new Date())} 00:00:01`,
          guestPhone: '',
          ShipID: '',
          CEShipName: '',
          GoodsFactor: '',
          ShipFactor: '',
          IsWithPail:false,
        },
        licenseNumberUserSelectId: [], // 批号选择id集合
        batchNumberUserSelectId: [], // 车号选择id集合
        detailInfo: {},
        getServiceIdList: [],
        MainOrder: '',
        guestIdDefaultValue: {
          Name: 'Name',
          GuestID: 'GuestID',
          Phone: 'guestPhone'
        },
        guestIdDefaultKeys: 'GuestId',
        goodsDefaultValue: {
          CEGoodsName: 'CEGoodsName',
          GoodsID: 'GoodsID',
        },
        shipDefaultValue: {
          CEShipName: 'CEShipName',
          ShipID: 'ShipID',
        },
        shipSupplierDefaultValue: {
          Name: 'shipSupplierName',
          FSupplierID: 'ShipFactor',
        },
        goodsSupplierDefaultValue: {
          Name: 'goodsSupplierName',
          FSupplierID: 'GoodsFactor',
        },
        goodsDefaultKeys: 'GoodsID',
        shipDefaultKeys: 'ShipID',
        shipSupplierKeys: 'ShipFactor',
        goodsSupplierKeys: 'GoodsFactor',
        TGuestIDDefaultValue: {
          Name: 'GuestName',
          GuestID: 'TGuestID',
        },
        TGuestIDDefaultKey: 'GuestID',
        TankIDDefaultKey: 'TankID',
        currentTank: 0,
        bargainDefaultValue: {
          BargainID: 'BargainID',
        },
        bargainDefaultKeys: 'BargainID',
        AttachBargainDefaultValue: {
          BatchNo: 'Location'
        },
        AttachBargainDefaultKey: 'BatchNo',
        carOrderBatchComponent: {
          select: ['BatchID'],
          checked: ['IsInTrade', 'IsOutTrade', 'IsTax'],
          inputButton: ['TankID'],
        },
        carOrderListComponent: {
          select: [],
          checked: ['IsDate'],
          datePicker: ['CarBeginDate', 'CarEndDate'],
          input: ['SmallBLNO']
        },
        OrderType: false, // 判断是否是装车还是卸车
        batchNumberCol: [],
        licenseNumberClo: [],
        Step: '', // 审核步骤
        fileUpload: '',
        desc: '',
        annexDetailList: [],
        editModleHeight: 0,
        detailTable: {},
        batchNumberListStyle: {},
        batchNumberListHeight: {
          minHeight: '200px',
          marginBottom: '35px'
        },
        licenseNumberListStyle: {},
        licenseNumberListHeight: {
          minHeight: '200px',
          marginBottom: '55px'
        },
        orderType: '',
        licenseNumberInput: 0,
        systemConfig3: '',
        systemConfig50: '',
        systemConfig17: '',
        systemConfig44: '',
        systemConfig1004: '',
        shipSID: '',
        unloadShipSID: '',
      };
    },
    computed: {
      ...mapGetters({
        userInfor: 'user/userInfor',
        goodDicList: 'dictionary/goodDicList',
        guestIDByConditionsList: 'dictionary/guestIDByConditionsList',
        bargainIDByConditionsList: 'dictionary/bargainIDByConditionsList',
        refGoodsByConditionsList: 'dictionary/refGoodsByConditionsList',
        carOrderBatch: 'dictionary/carOrderBatch',
        carOrderList: 'dictionary/carOrderList',
        TGuestIDByConditions: 'dictionary/TGuestIDByConditions',
        TankIDByConditions: 'dictionary/TankIDByConditions',
        dictionaryAction: 'dictionary/dictionaryAction',
        visitedViews: 'tags/visitedViews',
        shipDicList: 'dictionary/shipDicList',
        shipSupplierList: 'dictionary/shipSupplierList',

      }),
      fromList() {
        let list = [];
        if (this.$route.name === 'billLadingShip' || this.$route.name === 'addBillLadingShip') {
          list = [
            {label: '订单号', key: 'MainOrderID', type: 'input', disabled: true, must: true,},
            {
              label: '客户',
              key: 'Name',
              type: 'inputButton',
              tips: '...',
              dialog: 'showGuestId',
              disabled: this.editStart,
              must: true,
            },
            {
              label: '合同',
              key: 'BargainID',
              type: 'inputButton',
              dialog: 'showBargainID',
              disabled: true,
              must: true,
              code: 4052,
            },
            {
              label: '客户电话',
              key: 'guestPhone',
              type: 'input',
              disabled: true,
              must: true,
            },
            {
              label: '样品信息',
              key: 'Sample',
              type: 'input',
              disabled: this.editStart,
              must: false,
            },
            {
              label: '产品',
              key: 'CEGoodsName',
              type: 'inputButton',
              tips: '...',
              dialog: 'showGoodsID',
              disabled: this.editStart,
              must: true,
            },
            {
              label: '提单号',
              key: 'BLNO',
              type: 'input',
              list: this.getBlnoList,
              labelName: 'BLNO',
              value: 'BLNO',
              disabled: this.editStart,
              must: false,
            },
            {
              label: '提单数',
              key: 'BLNumber',
              type: 'input',
              disabled: this.editStart,
              must: true,
            },
            {
              label: '船名',
              key: 'CEShipName',
              type: 'inputButton',
              tips: '...',
              dialog: 'showShipID',
              disabled: this.editStart,
              must: true,
            },
            {
              label: '泊位',
              key: 'BerthID',
              type: 'select',
              list: this.getBerthList,
              labelName: 'BerthID',
              value: 'BerthID',
              disabled: this.editStart,
              must: false,
            },
            {
              label: '预计靠泊',
              key: 'PreDate',
              type: 'datePicker',
              disabled: this.editStart,
              must: true,
              default: `${this.$utils.getTimeByDay(new Date())} 00:00:01`,
            },
            {
              label: '提单结束日期',
              key: 'BLEndDate',
              type: 'datePicker',
              default: `${this.$utils.getTimeByDay(new Date())} 23:59:59`,
              disabled: this.editStart,
            },
            {
              label: '上一港',
              key: 'LeavePort',
              type: 'input',
              disabled: this.editStart,
              must: false,
            },
            {
              label: '下一港/目的港',
              key: 'ArrivePort',
              type: 'input',
              disabled: this.editStart,
              must: false,
            },
            {
              label: '航次',
              key: 'ShipTime',
              type: 'input',
              disabled: this.editStart,
              must: false,
            },
            {
              label: '船代',
              key: 'shipSupplierName',
              type: 'inputButton',
              tips: '...',
              dialog: 'showshipSupplier',
              disabled: this.editStart,
              must: false,
            },
            {
              label: '商检部门',
              key: 'BusinessDept',
              type: 'select',
              list: this.getBusinessDeptList,
              labelName: 'DeptName',
              value: 'BusinessDept',
              disabled: this.editStart,
              must: false,
            },
            {
              label: '联系电话',
              key: 'Phone',
              type: 'input',
              disabled: this.editStart,
              must: false,
            },
            {
              label: '货代',
              key: 'goodsSupplierName',
              type: 'inputButton',
              tips: '...',
              dialog: 'showgoodsSupplier',
              disabled: this.editStart,
              must: false,
            },
            {
              label: '提货人',
              key: 'GuestName',
              type: 'inputButton',
              tips: '...',
              dialog: 'showgetTGuest',
              disabled: this.editStart,
              must: true,
            },
            {
              label: '附加合同',
              key: 'Location',
              type: 'inputButton',
              tips: '...',
              dialog: 'showAttachBargain',
              disabled: this.editStart,
            },
            {
              label: '最小数量',
              key: 'MinNum',
              type: 'input',
              list: this.getBlnoList,
              labelName: 'MinNum',
              value: 'MinNum',
              disabled: this.editStart,
              must: false,
            },
            {
              label: '最大数量',
              key: 'MaxNum',
              type: 'input',
              list: this.getBlnoList,
              labelName: 'MaxNum',
              value: 'MaxNum',
              disabled: this.editStart,
              must: false,
            },
            {
              label: '外贸',
              key: 'IsWithPail',
              type: 'switch',
              default: false,
              disabled: this.editStart,
              width: '12.5%'
            },
            {
              label: '制表人',
              key: 'OperatorName',
              type: 'input',
              disabled: true,
              default: this.userInfor.nic,
            },
            {
              label: '制表日期',
              key: 'CreateDate',
              type: 'input',
              disabled: true,
              default: dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss'),
            },
          ];
        }
        else if (this.$route.name === 'billLadingUnloadShip' || this.$route.name === 'addBillLadingUnloadShip') {
          list = [
            {label: '订单号', key: 'MainOrderID', type: 'input', disabled: true, must: true,},
            {
              label: '客户',
              key: 'Name',
              type: 'inputButton',
              tips: '...',
              dialog: 'showGuestId',
              disabled: this.editStart,
              must: true,
            },
            {
              label: '合同',
              key: 'BargainID',
              type: 'inputButton',
              tips: '...',
              dialog: 'showBargainID',
              disabled: this.editStart,
              must: true,
              code: 4052,
            },
            {
              label: '客户电话',
              key: 'guestPhone',
              type: 'input',
              disabled: true,
              must: true,
            },
            {
              label: '样品信息',
              key: 'Sample',
              type: 'input',
              disabled: this.editStart,
              must: false,
            },
            {
              label: '产品',
              key: 'CEGoodsName',
              type: 'inputButton',
              tips: '...',
              dialog: 'showGoodsID',
              disabled: this.editStart,
              must: true,
            },
            {
              label: '提单号',
              key: 'BLNO',
              type: 'input',
              list: this.getBlnoList,
              labelName: 'BLNO',
              value: 'BLNO',
              disabled: this.editStart,
              must: false,
            },
            {
              label: '提单数',
              key: 'BLNumber',
              type: 'input',
              disabled: this.editStart,
              must: true,
            },
            {
              label: '船名',
              key: 'CEShipName',
              type: 'inputButton',
              tips: '...',
              dialog: 'showShipID',
              disabled: this.editStart,
              must: true,
            },
            {
              label: '泊位',
              key: 'BerthID',
              type: 'select',
              list: this.getBerthList,
              labelName: 'BerthID',
              value: 'BerthID',
              disabled: this.editStart,
              must: false,
            },
            {
              label: '预计靠泊',
              key: 'PreDate',
              type: 'datePicker',
              disabled: this.editStart,
              must: true,
              default: `${this.$utils.getTimeByDay(new Date())} 00:00:01`,
            },
            {
              label: '提单结束日期',
              key: 'BLEndDate',
              type: 'datePicker',
              default: `${this.$utils.getTimeByDay(new Date())} 23:59:59`,
              disabled: this.editStart,
            },
            {
              label: '上一港',
              key: 'LeavePort',
              type: 'input',
              disabled: this.editStart,
              must: false,
            },
            {
              label: '下一港/目的港',
              key: 'ArrivePort',
              type: 'input',
              disabled: this.editStart,
              must: false,
            },
            {
              label: '航次',
              key: 'ShipTime',
              type: 'input',
              disabled: this.editStart,
              must: false,
            },
            {
              label: '船代',
              key: 'shipSupplierName',
              type: 'inputButton',
              tips: '...',
              dialog: 'showshipSupplier',
              disabled: this.editStart,
              must: false,
            },
            {
              label: '商检部门',
              key: 'BusinessDept',
              type: 'select',
              list: this.getBusinessDeptList,
              labelName: 'DeptName',
              value: 'BusinessDept',
              disabled: this.editStart,
              must: false,
            },
            {
              label: '联系电话',
              key: 'Phone',
              type: 'input',
              disabled: this.editStart,
              must: false,
            },
            {
              label: '货代',
              key: 'goodsSupplierName',
              type: 'inputButton',
              tips: '...',
              dialog: 'showgoodsSupplier',
              disabled: this.editStart,
              must: false,
            },
            {
              label: '快检',
              key: 'IsNon',
              type: 'switch',
              default: false,
              disabled: this.editStart,
              width: '12.5%'
            },
            {
              label: '制表人',
              key: 'OperatorName',
              type: 'input',
              disabled: true,
              default: this.userInfor.nic,
            },
            {
              label: '制表日期',
              key: 'CreateDate',
              type: 'input',
              disabled: true,
              default: dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss'),
            },
          ];
        }
        return list;
      },
      guestIdDefaultParams() {
        let params = {
          guestId: this.formInline.GuestID ? this.formInline.GuestID : this.formInline.Name,
          goodsId: this.formInline.GoodsID ? this.formInline.GoodsID : this.formInline.CEGoodsName,
          bargainId: this.formInline.BargainID ? this.formInline.BargainID : '',
          serviceId: this.orderTypeC(this.shipSID, this.unloadShipSID),
        };
        let info = {
          type: 'BUSINESS',
          url: 'getRefVGuest',
          params,
        };
        return info;
      },
      bargainIDDefaultParams() {
        let params = {
          guestId: this.formInline.Name ? this.formInline.GuestID : '',
          goodsId: this.formInline.GoodsID ? this.formInline.GoodsID : this.formInline.CEGoodsName,
          bargainId: this.formInline.BargainID ? this.formInline.BargainID : '',
          serviceId: this.orderTypeC(this.shipSID, this.unloadShipSID),
        };
        let info = {
          type: 'BUSINESS',
          url: 'mainOrderGetBargainId',
          params,
        };
        if (!params.guestId) {
          info = false;
          this.formInline.BargainID = '';
        }
        return info;
      },
      refGoodsDefaultParams() {
        let params = this.systemConfig3 === '0' ? {
          bargainID: this.formInline.BargainID ? this.formInline.BargainID : '',
          searchCode: this.formInline.GoodsID ? this.formInline.GoodsID : this.formInline.CEGoodsName,
        } : {
          bargainID: this.formInline.BargainID ? this.formInline.BargainID : '',
          shipID: this.formInline.ShipID ? this.formInline.ShipID : '',
          goodsID: this.formInline.GoodsID ? this.formInline.GoodsID : '',
        };
        let info = {
          type: 'BUSINESS',
          url: this.systemConfig3 === '0' ? 'getBargainGoods' : 'getBargainShipGoods',
          params,
        };
        return info;
      },
      shipIdDefaultParams() {
        let params = this.systemConfig3 === '0' ? {
          searchCode: this.formInline.CEShipName ? this.formInline.CEShipName : '',
        } : {
          bargainID: this.formInline.BargainID ? this.formInline.BargainID : '',
          shipID: this.formInline.ShipID ? this.formInline.ShipID : '',
          goodsID: this.formInline.GoodsID ? this.formInline.GoodsID : '',
        };
        let info = {
          type: 'BUSINESS',
          url: this.systemConfig3 === '0' ? 'getShips' : 'getBargainShips',
          params,
        };

        return info;
      },
      shipSupplierDefaultParams() {
        let params = {
          fSupplierID: this.formInline.ShipFactor ? this.formInline.ShipFactor : '',
          type: 1
        };
        let info = {
          type: 'BUSINESS',
          url: 'getShipSupplier',
          params,
        };
        return info;
      },
      goodsSupplierDefaultParams() {
        let params = {
          fSupplierID: this.formInline.GoodsFactor ? this.formInline.GoodsFactor : '',
          type: 0
        };
        let info = {
          type: 'BUSINESS',
          url: 'getGoodsSupplier',
          params,
        };
        return info;
      },
      TGuestIDDefaultParams() {
        let params = {
          guestID: this.formInline.Name ? this.formInline.GuestID : '',
          bargainID: this.formInline.BargainID ? this.formInline.BargainID : '',
          goodsID: this.formInline.CEGoodsName ? this.formInline.GoodsID : '',
          tankOrPail: 'Tank',
          searchCode: this.formInline.Name ? this.formInline.GuestID : '',
          operatorID: this.userInfor.userName
        };
        let info = {
          type: 'BUSINESS',
          url: 'getHaveGoodGuest',
          params,
        };
        return info;
      },
      TankIDDefaultParams() {
        let params = {
          bargainID: this.formInline.BargainID ? this.formInline.BargainID : '',
          guestID: this.formInline.Name ? this.formInline.GuestID : '',
          goodsID: this.formInline.CEGoodsName ? this.formInline.GoodsID : '',
          billID: this.formInline.BillID,
          location: this.formInline.Location,
        };
        let info = {
          type: 'BUSINESS',
          url: this.orderTypeC('getOnShipTank', 'getOutShipTank'),
          params,
        };
        return info;
      },
      AttachBargainDefaultParams() {
        let params = {
          goodsId: this.formInline.CEGoodsName ? this.formInline.GoodsID : '',
          guestId: this.formInline.Name ? this.formInline.GuestID : '',
          bargainId: this.formInline.BargainID ? this.formInline.BargainID : '',
        };
        let info = {
          type: 'BUSINESS',
          url: 'getAttachBargain',
          params,
        };
        !params.guestId || !params.bargainId || !params.goodsId ? info = false : '';
        return info;
      },
      enclosureAction() {
        return [
          {width: 160, title: '附件描述', field: 'explain'},
          {width: 160, title: '附件名称', field: 'annexname'},
          {width: 160, title: '添加人', field: 'operatorid'},
          {width: 160, title: '添加时间', field: 'adddate'},
          {width: 160, title: '编辑', field: 'edit'},
        ]
      },
      batchFilterData: {
        get() {
          return this.batchNumberList.filter(v => v.updateFlg !== 'delete')
        },
        set(v) {
          v ? this.batchNumberList = v : '';
        }
      },
      licenseFilterData() {
        let arr = [];
        this.licenseNumberList.forEach(itme => {
          if (itme.updateFlg !== 'delete') {
            arr.push(itme);
          }
        });
        return arr;
      },
      TankIDDefaultValue() {
        if (this.orderType === 'loadShip') {
          return {
            AccountID: 'AccountID',
            BargainID: 'BargainID',
            BatchNo: 'BatchID',
            CanNumber: 'CanNumber',
            GoodsID: 'GoodsID',
            GoodsName: 'GoodsName',
            GuestID: 'GuestID',
            GuestName: 'GuestName',
            IsInTrade: 'IsInTrade',
            IsOutTrade: 'IsOutTrade',
            IsTax: 'IsTax',
            LockNumber: 'LockNumber',
            MadeNumber: 'MadeNumber',
            OrderNumber: 'OrderNumber',
            PassNo: 'PassNo',
            Remark: 'Remark',
            TankID: 'TankID',
          };
        }
        else if (this.orderType === 'unloadShip') {
          return {
            TankID: 'TankID',
            InOrderNumber: 'InOrderNumber',
            IsTax: 'IsTax',
            Number: 'Number',
            RealNumber: 'RealNumber',
            AffirmNumber: 'AffirmNumber',
            StateName: 'StateName',
            Remark: 'Remark',
          };
        }
      },
    },
    activated() {
      if (this.id !== this.$route.query.id) {
        this.init();
      }
    },
    created() {
      this.getSystemConfig('3');
      this.getSystemConfig('50');
      this.getSystemConfig('17');
      this.getSystemConfig('44');
      this.getSystemConfig('1004');
    },
    mounted() {
      this.editModleHeight = window.document.body.clientHeight - 139;
      this.pageType = this.$route.query.type;
      this.$route.name === 'addBillLadingShip' || this.$route.name === 'billLadingShip' ? this.orderType = 'loadShip' : '';
      this.$route.name === 'addBillLadingUnloadShip' || this.$route.name === 'billLadingUnloadShip' ? this.orderType = 'unloadShip' : '';
    },
    methods: {
      ...mapActions({
        getGoodDicList: 'dictionary/getGoodDicList',
        getShipDicList: 'dictionary/getShipDicList',
        getShipSupplierList: 'dictionary/getShipSupplierList',
        getGuestIDByConditionsList: 'dictionary/getGuestIDByConditionsList',
        getBargainIDByConditionsList: 'dictionary/getBargainIDByConditionsList',
        getRefGoodsByConditionsList: 'dictionary/getRefGoodsByConditionsList',
        getCarOrderBatch: 'dictionary/getCarOrderBatch',
        getCarOrderList: 'dictionary/getCarOrderList',
        getTGuestIDByConditions: 'dictionary/getTGuestIDByConditions',
        getTankIDByConditions: 'dictionary/getTankIDByConditions',
        getDictionaryAction: 'dictionary/getDictionaryAction',
        // getEnclosureAction: 'dictionary/getEnclosureAction',
      }),
      getSystemConfig(identityId) {
        //船舶资料弹出和产品资料弹出，根据3号业务配置(3号业务配置值为0时：是否需要船舶总计划  0:否；1：是)
        this.$services.postLoading({
          type: 'BUSINESS',
          url: 'getGet_SystemConfig',
          params: {
            accountId: this.userInfor.accountId,
            identityID: identityId
          },
        }).then(res => {
          identityId === '3' ? this.systemConfig3 = res.bean[0].Value : '';
          identityId === '50' ? this.systemConfig50 = res.bean[0].Value : '';
          identityId === '17' ? this.systemConfig17 = res.bean[0].Value : '';
          identityId === '44' ? this.systemConfig44 = res.bean[0].Value : '';
          identityId === '1004' ? this.systemConfig1004 = res.bean[0].Value : '';
        });
      },
      licenseNumberChange() {
        this.licenseNumberList.forEach((itme, i) => {
          if (itme.updateFlg !== 'delete') {
            this.$set(this.licenseNumberList[i], 'Number', this.licenseNumberInput);
          }
        });
      },
      btnConfirm(F, str, par) {
        this.$confirm(str, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          if (typeof F === "function") F(par);
        });
      },
      orderTypeC(a, b) {
        //a 装船  b卸船
        let re;
        this.orderType === 'loadShip' ? re = a : '';
        this.orderType === 'unloadShip' ? re = b : '';
        return re;
      },
      // 获取批号表格详情
      batchdetail(id) {
        this.$services.postLoading({
          type: 'BUSINESS',
          url: 'getShipOrderList',
          params: {
            accountId: this.userInfor.accountId,
            billId: String(id),
          },
        }).then(({bean}) => {
          this.batchNumberList = bean;
          this.batchNumberList.forEach((itme, key) => {
            itme.id = key + 1;
            itme.uid = this.$utils.getUid();
          });
        });
      },
      // 获取车号表格详情
      LicenseNumberdetail(id) {
        // this.$services.postLoading({
        //   type: 'BUSINESS',
        //   url: 'listCarOrderList',
        //   params: {
        //     accountId: this.userInfor.accountId,
        //     billId: String(id),
        //     webType: Number(this.$route.query.WebType),
        //   },
        // }).then(({bean}) => {
        //   this.licenseNumberList = bean;
        //   this.licenseNumberList.forEach((itme, key) => {
        //     itme.id = key + 1;
        //     itme.uid = this.$utils.getUid();
        //   });
        // });
      },
      inputSelectEven(value) {
        this.formInline.BLNO = value.BLNO
      },
      querySearch(queryString, cb) {
        let restaurants = this.getBlnoList;
        let results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
        // 调用 callback 返回建议列表的数据
        cb(results);
      },
      createFilter(queryString) {
        return restaurant => {
          return (restaurant.BLNO.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
        };
      },
      // 车号文件上传，上传使用fromData方式，借用element上传组件
      licenseFileEven(file) {
        this.uploadFileAPI(file);
        return false;
      },
      uploadFileAPI(file) {
        let fileReader = new FileReader();
        fileReader.readAsDataURL(file);
        fileReader.onload = e => {
          let base64 = e.target.result.split(',')[1];
          this.$services.postLoading({
            type: 'BUSINESS',
            url: 'getListExcelCarOrderList',
            params: {
              carListExcel: base64,
              suffix: file.name.split('.')[1],
            },
          }).then(res => {
            if (res.bean) {
              res.bean.forEach(itme => {
                delete itme.UpdateFlg;
                this.licenseNumberList.push(JSON.parse(JSON.stringify(
                  Object.assign(this.licenseNumberOriginData, {
                    uid: this.$utils.getUid(),
                    id: this.licenseNumberList.length + 1,
                    BillID: Number(this.$route.query.id),
                    SmallBLNO: this.formInline.BLNO,
                    AccountID: this.userInfor.accountId,
                    ListId: this.licenseNumberList.length + 1,
                    ShowIndex: 1,
                    State: 0,
                    updateFlg: 'add',
                  }, itme),
                )));
              });
            }
          });
        };
      },
      getType(file) {
        let filename = file;
        let index1 = filename.lastIndexOf('.');
        let index2 = filename.length;
        let type = filename.substring(index1, index2);
        return type;
      },
      // 按钮状态控制
      buttonStart(type) {
        let start = false;
        if ((this.$route.name === 'adminAddBillLadingUnload' || this.$route.name === 'adminAddbillLading')) {
          start = true;
        }
        switch (type) {
          case 1:
            if (!this.editStart || this.detailInfo.State !== 0) {
              start = true;
            }
            break;
          case 2:
            if (!this.editStart) {
              start = false;
            }
            else {
              start = true;
            }
            break;
          case 3:
            if (!this.editStart || this.detailInfo.State !== 0) {
              start = true;
            }
            break;
          case 6:
            if (!this.editStart || this.detailInfo.State === 91 || this.detailInfo.State === 100 || this.detailInfo.State === -1) {
              start = true;
            }
          case 7:
            if (!this.editStart || this.detailInfo.State !== 90) {
              start = true;
            }
            break;
          case 10:
            if (this.detailInfo.State === 0|| this.type === 'add') {
              start = true;
            }
        }
        return start;
      },
      pasteOrder() {
        let choose = false;
        this.$confirm('是否复制提单？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'info'
        }).then(() => {
          choose = true;
          this.licenseNumberList = []
        }).catch(() => {
        });
        this.visitedViews.forEach(v => {
          if (v.path === this.$route.path) {
            v.title = '新增' + v.title.replace(/详情/, '');
          }
        });
        this.$route.query.type = 'edit';
        this.type = 'add';
        this.editStart = false;
        this.$services.postLoading({
          type: 'ERP',
          url: 'getBillId',
          params: {
            tableId: 'MainOrder',
            accountId: this.userInfor.accountId,
          },
        }).then(res => {
          let bean = JSON.parse(res.bean);
          let BillID = bean[0].BillID;
          let FieldValue = bean[0].FieldValue;
          this.formInline.MainOrderID = FieldValue;
          this.MainOrder = FieldValue;
          this.id = BillID;
          this.$route.query.id = BillID;
          this.$set(this.formInline, 'BillID', BillID);
          this.$set(this.formInline, 'Remark', '');
          this.$set(this.formInline, 'OPBeginDate', '');
          this.$set(this.formInline, 'OPEndDate', '');
          delete this.detailInfo.IsRed;
          this.batchNumberList.forEach(v => {
            v.BillID = BillID;
            v.State = '';
            v.StateName = '';
            v.ShowIndex = '';
            v.ListID = '';
            v.updateFlg = 'add';
            v.RealNumber = '';
            v.Number = '';
            v.LeftNumber = '';
            v.AffirmNumber = '';
          });
          this.licenseNumberList.forEach(v => {
            v.BillID = BillID;
            v.State = '';
            v.StateName = '';
            v.ShowIndex = '';
            v.ListID = '';
            v.updateFlg = 'add';
          });
          choose ? this.licenseNumberList = [] : '';
        });
      },
      // 数据初始化
      init() {
        this.id = this.$route.query.id;
        this.type = this.$route.query.type;
        this.MainOrder = this.$route.query.MainOrder;
        this.tableOriginData();
        this.getGoodDicList();
        this.getShipDicList(this.systemConfig3 === '0' ? 3008 : 3060);
        this.getShipSupplierList();
        this.getGuestIDByConditionsList();
        this.getBargainIDByConditionsList();
        this.getRefGoodsByConditionsList(3002);

        this.getCarOrderBatch(this.orderTypeC(2101, 3101));
        this.getCarOrderList();
        this.getTGuestIDByConditions();
        this.getTankIDByConditions(this.orderTypeC(2150, 3003));
        // this.getEnclosureAction();
        if (this.$route.name === 'addBillLadingShip' || this.$route.name === 'addBillLadingUnloadShip') {
          this.getServiceId();
        }
        if (this.$route.query.type === 'edit') {
          this.formInline.BillID = this.$route.query.id;
          this.formInline.MainOrderID = this.$route.query.MainOrder;
          this.detail(this.id);
          this.editStart = false;
        }
        if (this.$route.query.type === 'info') {
          this.formInline.BillID = this.$route.query.id;
          this.formInline.MainOrderID = this.$route.query.MainOrder;
          this.detail(this.id);
        }
        if (this.$route.query.type === 'add') {
          this.editStart = false;
          this.formInline.BillID = this.id;
          this.formInline.MainOrderID = this.MainOrder;
          this.getAvailableDays();
        }
        this.getBlnoEven();
        this.getBerthEven();
        this.getBusinessDeptEven();
        this.getCheckChecking();
        this.getCheckProcess();
        this.annexDetailAPI();
      },
      // 时间范围控制
      pickerOptionsEnd(val) {
        let data = {};
        if (val === 'BLEndDate') {
          data = {
            disabledDate: time => (
              time.getTime() < dayjs(this.formInline.BLBeginDate).valueOf() - 24 * 1000 * 60 * 60
            ),
          };
        }
        return data;
      },
      // 附件上传前的钩子
      beforeAvatarUpload(file) {
        if (this.desc) {
          this.annexUploadAPI(file);
        }
        else {
          this.$message({
            message: '请填写上传附件的说明',
            type: 'warning',
          });
        }
        return false;
      },
      // 单据的附件详情查询
      annexDetailAPI() {
        this.$services.post({
          type: 'ERP',
          url: 'annexDetail',
          params: {
            accountId: this.userInfor.accountId,
            tableId: 'MainOrder',
            billsId: this.MainOrder
          },
        }).then(res => {
          this.annexDetailList = res.bean;
        });
      },
      // 单据的附件上传
      annexUploadAPI(file) {
        let listid = 0
        if (this.annexDetailList.length > 0) {
          this.annexDetailList.forEach(itme => {
            if (listid < itme.listid) {
              listid = itme.listid;
            }
          });
        }
        const $loading = Loading.service({
          target: document.querySelector('div.contain'),
          lock: true,
          fullscreen: false,
          text: '附件上传中',
          background: 'transparent',
        });
        let data = {
          updateFlg: 'add',
          accountid: this.userInfor.accountId,
          tableid: 'MainOrder',
          billsid: this.MainOrder,
          // listid: listid + 1,
          // showindex: listid + 1,
          explain: this.desc,
          annexname: file.file.name,
          operatorid: this.userInfor.userName,
          adddate: dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss'),
          annexsize: file.file.size / 1000,
        };
        this.$services.postUrlParams({
          type: 'ERP',
          url: 'annexUpload',
          urlParams: data,
          params: file.file,
        }).then(res => {
          $loading.close();
          if (res.code === '000') {
            this.$message({
              message: '上传成功',
              type: 'success',
            });
          }
          this.desc = '';
          this.uploadFileDesc = false;
          this.annexDetailAPI();
        });
      },
      // 单据附件删除
      fileDelete(itme) {
        this.$services.download({
          type: 'ERP',
          url: 'annexRemove',
          params: {
            accountId: this.userInfor.accountId,
            tableId: 'MainOrder',
            billsId: this.MainOrder,
            listId: itme.listid,
            showIndex: itme.showindex,
          },
        }).then(res => {
          this.annexDetailAPI();
          this.$message({
            message: '删除成功',
            type: 'success',
          });
        });
      },
      // 单据附件的下载
      fileDownload(itme) {
        this.$services.download({
          type: 'ERP',
          url: 'annexDownload',
          params: {
            accountId: this.userInfor.accountId,
            tableId: 'MainOrder',
            billsId: this.MainOrder,
            listId: itme.listid,
            showIndex: itme.showindex,
          },
        }).then(res => {
          this.$utils.downLoad(res, itme.annexname)
        });
      },
      // 获取默认有效天数
      getAvailableDays() {
        this.$services.post({
          type: 'GUESTBUSINESS',
          url: 'getAvailableDays',
          params: {
            accountId: this.userInfor.accountId,
          },
        }).then(res => {
          this.$set(this.formInline, 'AvailableDays', res.bean);
        });
      },
      // 审核
      doAudit() {
        if (this.systemConfig44 === '0') {
          if (this.detailInfo.OperatorID === this.userInfor.userName) {
            this.$message({
              message: '审核人不能与制单人相同！',
              type: 'error',
            });
            return;
          }
        }
        this.AuditHttp();
      },
      AuditHttp() {
        this.$services.post({
          type: 'ERP',
          url: 'doAudit',
          params: {
            pProId: 100001,
            aAccountId: this.userInfor.accountId,
            aTableId: 'MainOrder',
            aBillId: this.id,
            aAuditStep: this.Step,
            pFuncId: 612,
            aOperatorId: this.userInfor.id,
            pAccountId: this.userInfor.accountId,
          },
        }).then(res => {
          if (typeof res.bean === 'string') {
            let bean = JSON.parse(res.bean);
            if (bean.RetMessage) {
              this.$message({
                message: JSON.parse(res.bean).RetMessage,
                type: 'warning',
              });
            }
            else {
              this.$message({
                message: '审核成功！',
                type: 'success',
              });
            }
          }
          this.editStart = true;
          this.detail(this.id);
          this.$forceUpdate();
          storage.$set({
            key: 'customerServiceTable',
            parameter: true,
          });
        });
      },
      // 退审
      doCancleAudit() {
        this.$services.post({
          type: 'ERP',
          url: 'doCancleAudit',
          params: {
            pProId: 100001,
            aAccountId: this.userInfor.accountId,
            aTableId: 'MainOrder',
            aBillId: this.id,
            aAuditStep: -1,
            pFuncId: 612,
            aOperatorId: this.userInfor.id,
            pAccountId: this.userInfor.accountId,
          }
        }).then(res => {
          if (typeof res.bean === 'string') {
            let bean = JSON.parse(res.bean);
            if (bean.RetMessage) {
              this.$message({
                message: JSON.parse(res.bean).RetMessage,
                type: 'warning',
              });
            }
          }
          this.$router.go(-1);
          // this.detail(this.id);
        });
      },
      // 完成
      doFinish() {
        this.$services.post({
          type: 'ERP',
          url: 'doFinish',
          params: {
            pProId: 100001,
            aAccountId: this.userInfor.accountId,
            aTableId: 'MainOrder',
            aBillId: this.id,
            aAuditStep: 0,
            pFuncId: 612,
            aOperatorId: this.userInfor.id,
            pAccountId: this.userInfor.accountId,
          }
        }).then(res => {
          if (typeof res.bean === 'string') {
            let bean = JSON.parse(res.bean);
            if (bean.RetMessage) {
              this.$message({
                message: JSON.parse(res.bean).RetMessage,
                type: 'warning',
              });
            }
          }
          this.$router.go(-1);
        });
      },
      // 作废
      operationDeleteEven() {
        // if (this.systemConfig1004 === '0') {
        //   this.$message({
        //     message: '审核后不允许作废！',
        //     type: 'error',
        //   });
        //   return;
        // }
        this.operationDeleteHttp();
      },
      operationDeleteHttp() {
        this.$services.postLoading({
          type: 'ERP',
          url: 'doBlankOut',
          params: {
            aAccountId: this.userInfor.accountId,
            aTableId: 'MainOrder',
            aBillId: this.id,
            aAuditStep: 0,
            pFuncId: 612,
            aOperatorId: this.userInfor.id,
            pAccountId: this.userInfor.accountId,
          },
        }).then(res => {
          if (typeof res.bean === 'string') {
            let bean = JSON.parse(res.bean);
            if (bean.RetMessage) {
              this.$message({
                message: JSON.parse(res.bean).RetMessage,
                type: 'warning',
              });
            }
            else {
              this.$message({
                message: '作废成功！',
                type: 'success',
              });
            }
          }
          this.detail(this.id);
          storage.$set({
            key: 'customerServiceTable',
            parameter: true,
          });
        });
      },
      operationRevokeEven() {
        this.$services.postLoading({
          type: 'ERP',
          url: 'doCancleAudit',
          params: {
            aAccountId: this.userInfor.accountId,
            aTableId: 'MainOrder',
            aBillId: this.id,
            aAuditStep: 0,
            aFuncId: 612,
            aOperatorId: this.userInfor.id,
            pAccountId: this.userInfor.accountId,
            pFuncId: 612,
          },
        }).then(res => {
          if (typeof res.bean === 'string') {
            let bean = JSON.parse(res.bean);
            if (bean.RetMessage) {
              this.$message({
                message: JSON.parse(res.bean).RetMessage,
                type: 'warning',
              });
            }
            else {
              this.$message({
                message: '退审成功！',
                type: 'success',
              });
            }
          }
          this.detail(this.id);
          storage.$set({
            key: 'customerServiceTable',
            parameter: true,
          });
        });
      },
      // 获取单据审核信息
      getCheckChecking() {
        this.$services.post({
          type: 'ERP',
          url: 'getCheckChecking',
          params: {
            accountId: this.userInfor.accountId,
            tableId: 'MainOrder',
            billId: this.id,
          },
        }).then(res => {
          if (res.bean) {
            this.Step = res.bean.length;
          }
          else {
            this.Step = 0;
          }
        });
      },
      // 获取单据审核流程信息，窗体加载时获取
      getCheckProcess() {
        this.$services.post({
          type: 'ERP',
          url: 'getCheckProcess',
          params: {
            accountId: this.userInfor.accountId,
            tableId: 'MainOrder',
          },
        }).then(res => {
        });
      },
      openDialog(key, row = null, code, orgList) {
        let orgIndex;
        orgList ? orgIndex = orgList.findIndex(x => {
          return x.uid == row.row.uid;
        }) : '';
        if (orgIndex) this.currentTank = orgIndex;
        if (key === 'batch') {
          this.getInCarBatchId();
          return;
        }
        if (code) this.getDictionaryAction(code);
        this[key] = !this[key];
      },
      async getInCarBatchId() {
        if (!this.formInline.BLNumber && this.formInline.BLNumber !== 0) {
          this.$message({
            message: '请填写提单数',
            type: 'warning',
          });
        }
        const {bean} = await this.$services.post({
          type: 'BUSINESS',
          url: 'getShipOrderList',
          params: {
            accountId: this.userInfor.accountId,
            bargainId: this.formInline.BargainID,
            goodsId: this.formInline.GoodsID,
            guestId: this.formInline.GuestID,
            billId: this.formInline.BillID,
            blNumber: this.formInline.BLNumber,
          },
        });
        bean.forEach((itme, key) => {
          itme.updateFlg = 'add';
        });
        this.batchNumberList = bean;
      },
      // 表格初始化数据处理
      tableOriginData() {
        this.fromList.forEach(itme => {
          if (itme.key) this.$set(this.formInline, itme.key, '');
          if (itme.default || typeof itme.default === 'boolean') this.$set(this.formInline, itme.key, itme.default);
        });
        this.batchNumberCol.forEach(itme => {
          if (itme.field === 'IsInTrade' || itme.field === 'IsOutTrade' || itme.field === 'IsTax') {
            this.$set(this.batchNumberOriginData, itme.field, false);
          }
          else {
            this.$set(this.batchNumberOriginData, itme.field, null);
          }
        });
        this.licenseNumberClo.forEach(itme => {
          if (itme.field === 'IsBL' || itme.field === 'IsDate') {
            this.$set(this.licenseNumberOriginData, itme.field, false);
          }
          this.$set(this.licenseNumberOriginData, itme.field, null);
        });
      },
      // 取装卸车服务编号
      getServiceId() {
        let type;
        if (this.$route.name === 'addBillLadingShip') {
          type = 1;
        }
        else if (this.$route.name === 'addBillLadingUnloadShip') {
          type = 0;
        }
        this.$services.postLoading({
          type: 'BUSINESS',
          url: 'getServiceIdWeb',
          params: {
            accountId: this.userInfor.accountId,
            orderType: '0,1'
          },
        }).then(res => {
          this.getServiceIdList = res.bean;

          this.getServiceIdList.forEach((v) => {
            if (v.ServiceName === '装船') {
              this.shipSID = v.ServiceID;
            }
            if (v.ServiceName === '卸船') {
              this.unloadShipSID = v.ServiceID;
            }
          })
        });
      },
      // 获取台账详情
      detail(id) {
        this.$services.postLoading({
          type: 'BUSINESS',
          url: 'detailShip',
          params: {
            accountId: this.userInfor.accountId,
            billId: id,
          },
        }).then(({bean}) => {
          this.detailTable = bean;
          this.$set(this.formInline, 'BillID', bean.BillID);
          this.$set(this.formInline, 'GuestID', bean.GuestID);
          this.$set(this.formInline, 'Name', bean.GuestName);
          this.$set(this.formInline, 'BargainID', bean.BargainID);
          this.$set(this.formInline, 'CEGoodsName', bean.GoodsName);
          this.$set(this.formInline, 'GoodsID', bean.GoodsID);
          this.$set(this.formInline, 'BLNO', bean.BLNO);
          this.$set(this.formInline, 'BLNumber', bean.BLNumber);
          this.$set(this.formInline, 'BLBeginDate', bean.BLBeginDate);
          this.$set(this.formInline, 'BLEndDate', bean.BLEndDate);
          this.$set(this.formInline, 'PreDate', bean.PreDate);
          this.$set(this.formInline, 'Location', bean.Location);
          this.$set(this.formInline, 'OperatorName', bean.OperatorName);
          this.$set(this.formInline, 'IsNon', bean.IsNon !== 0);
          this.$set(this.formInline, 'IsWithPail', bean.IsWithPail);
          this.$set(this.formInline, 'ExtractSample', bean.ExtractSample !== null && bean.ExtractSample !== 0);
          this.$set(this.formInline, 'CreateDate', bean.CreateDate);
          this.$set(this.formInline, 'OperatorID', bean.OperatorID);
          this.$set(this.formInline, 'Remark', bean.Remark);
          this.$set(this.formInline, 'SpecialRequest', bean.SpecialRequest);
          this.$set(this.formInline, 'AvailableDays', bean.AvailableDays);
          this.$set(this.formInline, 'GuestName', bean.GuestName);
          this.$set(this.formInline, 'guestPhone', bean.GuestPhone);
          this.$set(this.formInline, 'Sample', bean.Sample);
          this.$set(this.formInline, 'ShipID', bean.ShipID);
          this.$set(this.formInline, 'CEShipName', bean.CEShipName);
          this.$set(this.formInline, 'BerthID', bean.BerthID);
          this.$set(this.formInline, 'LeavePort', bean.LeavePort);
          this.$set(this.formInline, 'ArrivePort', bean.ArrivePort);
          this.$set(this.formInline, 'ShipTime', bean.ShipTime);
          this.$set(this.formInline, 'ShipFactor', bean.ShipFactor);
          this.$set(this.formInline, 'shipSupplierName', bean.ShipFactorName);
          this.$set(this.formInline, 'BusinessDept', bean.BusinessDept);
          this.$set(this.formInline, 'Phone', bean.Phone);
          this.$set(this.formInline, 'GoodsFactor', bean.GoodsFactor);
          this.$set(this.formInline, 'goodsSupplierName', bean.GoodsFactorName);
          this.$set(this.formInline, 'MinNum', bean.MinNum);
          this.$set(this.formInline, 'MaxNum', bean.MaxNum);

          if (bean.NeedAssay !== null) this.$set(this.formInline, 'NeedAssay', bean.NeedAssay);
          this.batchNumberList = bean.shipOrderLists;
          if (this.batchNumberList.length > 0) {
            this.batchNumberList.forEach((itme, key) => {
              itme.id = key + 1;
              itme.uid = this.$utils.getUid();
            });
          }
          this.detailTable.shipOrderLists = this.batchNumberList;

          this.detailInfo = bean;
          this.$nextTick(() => {
            this.$refs.batchTable.initTable();
            this.$nextTick(() => {
              this.$refs.licenseTable.initTable();
            })
          })
        });
      },
      // 添加table数据列
      async addNewBatchNumberData(callback, dataItem) {
        let beanData = [];
        let res={};
        if (this.$route.name === 'billLadingUnloadShip' || this.$route.name === 'addBillLadingUnloadShip') {
          res = await this.$services.post({
            type: 'BUSINESS',
            url: 'getOutShipBath',
            params: {
              bargainID: this.formInline.BargainID ? this.formInline.BargainID : '',
              guestID: this.formInline.Name ? this.formInline.GuestID : '',
              goodsID: this.formInline.CEGoodsName ? this.formInline.GoodsID : '',
              billID: this.formInline.BillID,
              location: this.formInline.Location,
            },
          });
          beanData = res.bean;
        }
        if(!res.code){
          let data = {
            uid: this.$utils.getUid(),
            id: this.batchNumberList.length + 1,
            BillID: Number(this.$route.query.id),
            AccountID: this.userInfor.accountId,
            ShowIndex: 1,
            State: 0,
            updateFlg: 'add', // 添加数据时添加updateFlg=add表示添加
            IsOutTrade: false,
            IsInTrade: true,
            IsTax: false,
            BatchID: beanData[0] ? beanData[0].BatchID : '',
          };
          if (dataItem) {
            Object.keys(this.TankIDDefaultValue).forEach(key => {
              data[this.TankIDDefaultValue[key]] = dataItem[key];
            });
          }
          this.batchNumberList.push(JSON.parse(JSON.stringify(
            Object.assign({}, this.batchNumberOriginData, data),
          )));
          this.$nextTick(() => {
            if (typeof callback === 'function') callback();
            this.$forceUpdate();
          });
        }else {
          //卸船的批号
          if(res.code==='000'){
            let data = {
              uid: this.$utils.getUid(),
              id: this.batchNumberList.length + 1,
              BillID: Number(this.$route.query.id),
              AccountID: this.userInfor.accountId,
              ShowIndex: 1,
              State: 0,
              updateFlg: 'add', // 添加数据时添加updateFlg=add表示添加
              IsOutTrade: false,
              IsInTrade: true,
              IsTax: false,
              BatchID: beanData[0] ? beanData[0].BatchID : '',
            };
            data.BatchID=beanData[0].BatchNo;

            if (dataItem) {
              Object.keys(this.TankIDDefaultValue).forEach(key => {
                data[this.TankIDDefaultValue[key]] = dataItem[key];
              });
            }
            this.batchNumberList.push(JSON.parse(JSON.stringify(
              Object.assign({}, this.batchNumberOriginData, data),
            )));
            this.$nextTick(() => {
              if (typeof callback === 'function') callback();
              this.$forceUpdate();
            });
          }
        }
      },
      addNewLicenseNumberData(callback) {
        this.licenseNumberList.push(JSON.parse(JSON.stringify(
          Object.assign(this.licenseNumberOriginData, {
            uid: this.$utils.getUid(),
            id: this.licenseNumberList.length + 1,
            BillID: Number(this.$route.query.id),
            SmallBLNO: this.formInline.BLNO,
            AccountID: this.userInfor.accountId,
            ListId: this.licenseNumberList.length + 1,
            ShowIndex: 1,
            IsSingle: 1,
            State: 0,
            updateFlg: 'add',
          }),
        )));
        this.$nextTick(() => {
          if (typeof callback === 'function') callback();
        });
      },
      // 合同号弹出选择
      getBargainEven() {
        let params = {
          accountId: this.userInfor.accountId,
          guestId: this.formInline.GuestID ? this.formInline.GuestID : '',
          goodsId: this.formInline.Name ? this.formInline.GoodsID : '',
          serviceId: (this.$route.name === 'billLadingShip' || this.$route.name === 'addBillLadingShip') ? this.shipSID : this.unloadShipSID,
        };
        this.$services.postLoading({
          type: 'BUSINESS',
          url: 'mainOrderGetBargainId',
          params,
        }).then(res => {
          this.bargainList = res.bean;
        });
      },
      // 产品弹出选择
      getRefGoodsAPI() {
        let params = {
          accountId: this.userInfor.accountId,
          bargainId: this.formInline.BargainID,
          goodsId: this.formInline.GoodsID,
        };
        this.$services.postLoading({
          type: 'BUSINESS',
          url: 'getRefGoods',
          params,
        }).then(res => {
          this.getRefGoodsList = res.bean;
        });
      },
      // 客户弹出选择
       getRefVGuestAPI() {
        let params = {
          accountId: this.userInfor.accountId,
          guestId: this.formInline.GuestID ? this.formInline.GuestID : '',
          goodsId: this.formInline.GoodsID ? this.formInline.GoodsID : '',
          serviceId: (this.$route.name === 'billLadingShip' || this.$route.name === 'addBillLadingShip') ? this.shipSID : this.unloadShipSID,
        };
        this.$services.postLoading({
          type: 'BUSINESS',
          url: 'getRefVGuest',
          params,
        }).then(res => {
          this.guestIDList = res.bean;
        });
      },
      // 提单号接口
      getBlnoEven() {
        let params = {
          accountId: this.userInfor.accountId,
        };
        this.$services.postLoading({
          type: 'BUSINESS',
          url: 'getBlno',
          params,
        }).then(res => {
          this.getBlnoList = res.bean;
        });
      },
      // 泊位接口
      getBerthEven() {
        let params = {
          accountId: this.userInfor.accountId,
        };
        this.$services.postLoading({
          type: 'BUSINESS',
          url: 'getBerth',
          params,
        }).then(res => {
          this.getBerthList = res.bean;
        });
      },
      // 商检部门接口
      getBusinessDeptEven() {
        let params = {
          accountId: this.userInfor.accountId,
        };
        this.$services.postLoading({
          type: 'BUSINESS',
          url: 'getBusinessDept',
          params,
        }).then(res => {
          this.getBusinessDeptList = res.bean;
        });
      },
      // 提货人编号
      getTGuestNum() {
        let params = {
          accountId: this.userInfor.accountId,
        };
        this.$services.postLoading({
          type: 'BUSINESS',
          url: 'getTGuest',
          params,
        }).then(res => {
          this.getTGuestNumList = res.bean;
        });
      },
      selectRow(row) {
        this.$refs.pointSet.setCurrentRow(row);
      },
      clickFn(row) {
        this.$refs.pointSet.clearSelection();
        this.$refs.pointSet.toggleRowSelection(row);
      },
      // 用户选择表格事件
      batchNumberSelectionChange(selection) {
        let idAll = [];
        selection.forEach(itme => {
          idAll.push(itme.uid);
        });
        this.batchNumberUserSelectId = idAll;
      },
      licenseNumberSelectionChange(selection) {
        let idAll = [];
        selection.forEach(itme => {
          idAll.push(itme.uid);
        });
        this.licenseNumberUserSelectId = idAll;
      },
      // 删除
      batchNumberDelete() {
        if (this.batchNumberUserSelectId.length < 1) {
          this.$message({
            type: 'warning',
            message: '暂未选择要删除的数据',
          });
          return false;
        }
        this.$confirm('是否删除该条数据?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          this.batchNumberUserSelectId.forEach(itme => {
            this.batchNumberList.forEach((batchInfo, batchKey) => {
              if (itme === batchInfo.uid) {
                let data = batchInfo;
                data.updateFlg = 'delete';
                this.batchNumberList.splice(batchKey, data);
              }
            });
          });
        });
      },
      licenseNumberDelete() {
        if (this.licenseNumberUserSelectId.length < 1) {
          this.$message({
            type: 'warning',
            message: '暂未选择要删除的数据',
          });
          return false;
        }
        this.$confirm('是否删除该条数据?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          this.licenseNumberUserSelectId.forEach(itme => {
            this.licenseNumberList.forEach((batchInfo, batchKey) => {
              if (itme === batchInfo.uid) {
                let data = batchInfo;
                data.updateFlg = 'delete';
                this.licenseNumberList.splice(batchKey, data);
              }
            });
          });
        });
      },
      // 获取地点
      getAttachBargainAPI() {
        this.$services.post({
          type: 'BUSINESS',
          url: 'getAttachBargain',
          params: {
            accountId: this.userInfor.accountId,
            goodsId: this.formInline.GoodsID,
            guestId: this.formInline.GuestID,
            bargainId: this.formInline.BargainID
          }
        }).then(res => {
        })
      },
      // 数据校验
      dataCheck() {
        let start = false;
        let arr = [
          {key: 'Name', tips: '请选择客户',},
          {key: 'BargainID', tips: '请选择合同号',},
          {key: 'CEGoodsName', tips: '请选择产品',},
          {key: 'BLNumber', tips: '请填写提单数',},
          {key: 'PreDate', tips: '请选择提单结束日期',},
          {key: 'GoodsID', tips: '请选择产品',},
          {key: 'GuestID', tips: '请选择客户',},
        ];
        arr.forEach(itme => {
          if (!this.detailInfo[itme.key] && this.detailInfo[itme.key] !== 0) {
            start = true;
            this.$message({
              message: itme.tips,
              type: 'warning',
            });
          }
        });
        return start;
      },
      checkMustFlied(ot) {
        if (!this.detailInfo.ShipID) {
          this.$message({
            message: '船舶不可为空！',
            type: 'error',
          });
          return false;
        }
        if (!this.detailInfo.BLNumber) {
          this.$message({
            message: '提单数量不能为空或者零！',
            type: 'error',
          });
          return false;
        }
        let batchNumber = 0;
        this.batchNumberList.filter(v=>{ return v.updateFlg!=='delete' }).forEach((itme, key) => {
          batchNumber = this.$utils.FloatCalculation(batchNumber, Number(itme.Number), 'add');
        });
        if (batchNumber < 0 || batchNumber === 0) {
          this.$message({
            message: '细单数量之和不能小于等于0！',
            type: 'error',
          });
          return false;
        }
        if (batchNumber != this.detailInfo.BLNumber) {
          this.$message({
            message: '细单中数量之和不等于提单数！',
            type: 'error',
          });
          return false;
        }
        if (ot === 'loadShip' && !this.formInline.GuestID) {
          this.$message({
            message: '出货订单必须有提货人！',
            type: 'error',
          });
          return false;
        }
        this.queryCheckForm();

      },
      queryCheckForm() {
        if (!this.detailInfo.BLNO || this.detailInfo.BLNO === 0) {
          this.$confirm('提单号为空，是否继续保存？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }).then(() => {
            this.chechShipIsBack();
          }).catch(() => {
            return false;
          });
        } else {
          this.chechShipIsBack();
        }
      },
      chechShipIsBack() {
        this.$services.postLoading({
          type: 'BUSINESS',
          url: 'isShipBlack',
          params: {
            AccountID: this.userInfor.accountId,
            shipID: this.detailInfo.ShipID
          }
        }).then(res => {
          if (res.bean.length > 0) {
            if (res.bean[0].BlackState == 0) {
              this.$confirm('该船舶当前处于黑名单状态，是否继续保存？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
              }).then(() => {
                this.checkBLNORepeat();
              }).catch(() => {
                return false;
              });
            } else if (res.bean[0].BlackState == -1) {
              this.checkBLNORepeat();
            } else if (res.bean[0].BlackState == 1) {
              this.$message({
                message: '警告次数超过三次，不允许保存',
                type: 'error',
              });
              return
            }
          } else {
            return
          }
        });
      },
      checkBLNORepeat() {
        this.$services.postLoading({
          type: 'BUSINESS',
          url: 'isBLNORepeat',
          params: {
            AccountID: this.userInfor.accountId,
            billID: this.$route.query.id,
            guestID: this.formInline.GuestID,
            BLNO: this.formInline.BLNO
          }
        }).then(res => {
          if (res.bean.length > 0) {
            this.$confirm(`该提货人之前已用过这个提单号，订单号为:${res.bean[0].MainOrderID}是否继续保存？`, '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
            }).then(() => {
              this.checkBLEndDateToBargain();
            }).catch(() => {
              return false;
            });
          } else {
            this.checkBLEndDateToBargain();
          }
        });
      },
      checkBLEndDateToBargain() {
        //比较时间戳
        let orderTime = Date.parse(this.detailInfo.BLEndDate);
        this.$services.postLoading({
          type: 'BUSINESS',
          url: 'isBLEndDateToBargain',
          params: {
            AccountID: this.userInfor.accountId,
            bargainID: this.detailInfo.BargainID,
          }
        }).then(res => {
          if (res.bean.length > 0) {
            if (!orderTime > Date.parse(res.bean[0].EndDate)) {
              this.$message({
                message: '订单有效期大于合同结束日期，不可保存',
                type: 'error',
              });
              return false;
            } else {
              this.orderType === 'loadShip' ? this.checkNumber() : '';
              this.orderType === 'unloadShip' ? this.checkBargainDelay() : '';
            }
          } else {
            this.orderType === 'loadShip' ? this.checkNumber() : '';
            this.orderType === 'unloadShip' ? this.checkBargainDelay() : '';
          }
        });
      },
      checkNumber() {
        let batchNumber = 0;
      this.batchNumberList.filter(e => e.updateFlg !== 'delete').forEach((itme, key) => {
        batchNumber = batchNumber + Number(itme.Number);
      });
        if (batchNumber > Number(this.formInline.MaxNum)) {
          this.$confirm('细单数量之和大于最大数量，是否继续保存？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }).then(() => {
            this.checkLockNumber();
          }).catch(() => {
            return false;
          });
        } else {
          this.checkLockNumber();
        }
      },
      checkLockNumber() {
        console.log(this.systemConfig50,this.systemConfig17)
        if (this.systemConfig50 === '1') {
          //考虑锁库存超可提数判断
          if (this.systemConfig17 === '0') {
            //批号：['+BatchNo+']的提货数量大于该批号的可提数量['+KNumber+']+锁库存量['+LNumber+'],不能保存
            this.batchNumberList.forEach((itme) => {
              if (Number(itme.Number) > Number(itme.CanNumber)) {
                this.$message({
                  message: `批号为${itme.BatchNo}的提货数量大于该批号的可提数量${itme.KNumber}，不能保存！`,
                  type: 'error',
                });
                return;
              }
            });
            this.saveHttp();
          } else {
            this.$confirm(`批号为${itme.BatchNo}的提货数量大于该批号的可提数量${itme.KNumber}，是否继续保存？`, '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
            }).then(() => {
              this.saveHttp();
            }).catch(() => {
              return false;
            });
          }
        } else {
          if (this.systemConfig17 === '0') {
            //批号：['+BatchNo+']的提货数量大于该批号的可提数量['+KNumber+']+锁库存量['+LNumber+'],不能保存
            this.batchNumberList.forEach((itme) => {
              if (Number(itme.Number) > Number(itme.CanNumber)) {
                this.$message({
                  message: `批号为${itme.BatchNo}的提货数量大于该批号的可提数量${itme.KNumber}+锁库存量${itme.LockNumber}，不能保存！`,
                  type: 'error',
                });
                return;
              }
            });
            this.saveHttp();
          } else {
            this.$confirm(`批号为${itme.BatchNo}的提货数量大于该批号的可提数量${itme.KNumber}+锁库存量${itme.LockNumber}，是否继续保存？`, '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
            }).then(() => {
              this.saveHttp();
            }).catch(() => {
              return false;
            });
          }
        }
      },
      checkBargainDelay() {
        this.$services.postLoading({
          type: 'BUSINESS',
          url: 'getBargainDelay',
          params: {
            AccountID: this.userInfor.accountId,
            bargainID: this.detailInfo.BargainID,
          }
        }).then(res => {
          if (res.bean.length > 0) {
            this.$confirm(`该合同: ${this.detailInfo.BargainID}处于延期中，是否继续保存？`, '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
            }).then(() => {
              this.checkTankTax();
            }).catch(() => {
              return false;
            });
          } else {
            this.checkTankTax();
          }
        });
      },
      checkTankTax() {
        let taxTank = [];
        this.$services.postLoading({
          type: 'BUSINESS',
          url: 'getTankTax',
          params: {
            AccountID: this.userInfor.accountId,
          }
        }).then(res => {
          if (res.bean.length > 0) {
            //获取保税罐
            res.bean.forEach((v) => {
              if (v.IsTax) {
                taxTank.push(v.TankID);
              }
            });
            this.batchNumberList.filter(v=>{ return v.updateFlg!=='delete' }).forEach((itme, key) => {
              if (itme.IsTax == 1 && taxTank.indexOf(itme.TankID)===-1 ) {
                this.$message({
                  message: '保税货物需要保税罐！',
                  type: 'error',
                });
                return;
              }else {
                this.checkSafeCapacity();
              }
            });
          }else {
            this.$message({
              message: '保税货物需要保税罐！',
              type: 'error',
            });
            return;
          }
        });


      },
      safeCapacityHttp(itme){
           return this.$services.postLoading({
             type: 'BUSINESS',
             url: 'getSafeCapacity',
             params: {
               AccountID: this.userInfor.accountId,
               tankID:itme.TankID,
               number:itme.Number,
               goodsID:this.detailInfo.GoodsID
             }
           })
      },
      handlerConfirm(index, data) {
        if(data[index].bean.length) {
           let itme = this.batchNumberList.filter(v=>{ return v.updateFlg!=='delete' })[index];
           this.$confirm(`罐号:${itme.TankID}超过安全罐容，是否继续保存？`, '提示', {
             confirmButtonText: '确定',
             cancelButtonText: '取消',
             type: 'warning',
           }).then(() => {
             if(index + 1 < data.length) {
               this.handlerConfirm(index + 1, data);
             }else {
               this.checkIsTankOtherGoods();
             }
           }).catch(()=>{
             return false;
           })
        }else {
          this.checkIsTankOtherGoods();
        }
      },
      checkSafeCapacity() {
        //遍历this.batchNumberList，每一项要请求，然后判断罐容，然后询问弹出框
        let promiseAll = this.batchNumberList.filter(v=>{ return v.updateFlg!=='delete' })
          .map(item => this.safeCapacityHttp(item));
        Promise.all(promiseAll).then((data) => {
          this.handlerConfirm(0, data);
        })
      },
      IsTankOtherGoodsHttp(itme){
        return this.$services.postLoading({
          type: 'BUSINESS',
          url: 'checkIsTankOtherGoods',
          params: {
            AccountID: this.userInfor.accountId,
            tankID:itme.TankID,
            goodsID:this.detailInfo.GoodsID
          }
        })
      },
      handlerConfirm1(index, data) {
        if(data[index].bean.length) {
          let itme = this.batchNumberList.filter(v=>{ return v.updateFlg!=='delete' })[index];
          this.$confirm(`罐号:${itme.TankID}现有库存已存在别的产品，是否继续保存？`, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }).then(() => {
            if(index + 1 < data.length) {
              this.handlerConfirm1(index + 1, data);
            }else {
              this.saveHttp();
            }
          }).catch(()=>{
            return false;
          })
        }else {
          this.saveHttp();
        }
      },
      checkIsTankOtherGoods(){
        let promiseAll = this.batchNumberList.filter(v=>{ return v.updateFlg!=='delete' })
          .map(item => this.IsTankOtherGoodsHttp(item));
        Promise.all(promiseAll).then((data) => {
          this.handlerConfirm1(0, data);
        })
      },
      checkByOrderType() {
        if (this.orderType === 'loadShip') {
          this.checkMustFlied('loadShip');
        } else if (this.orderType === 'unloadShip') {
          this.checkMustFlied('unloadShip');
        }
      },
      checkForm() {
        this.$refs['topForm'].validate((valid) => {
          if (valid) {
            this.complete();
          } else {
            this.$message({
              message: '请将选项填写完整',
              type: 'warning',
            });
            return false;
          }
        });
      },
      complete() {
        let batchStart = false;
       //用for代替forEach因为forEach不能return停止循环
        for(let key=0;key< this.batchNumberList.length;key++){
          if (this.batchNumberList[key].updateFlg !== 'delete') {
            if (!this.batchNumberList[key].IsTax) this.batchNumberList[key].IsTax = 0;
            if (!this.batchNumberList[key].IsInTrade) this.batchNumberList[key].IsInTrade = 0;
            if (!this.batchNumberList[key].IsOutTrade) this.batchNumberList[key].IsOutTrade = 0;
            if (this.orderType === 'loadShip') {
              if (this.batchNumberList[key].IsOutTrade == 1 && !this.batchNumberList[key].PassNo) {
                this.$message({
                  message: '外贸货物需要通关之后才能出货！',
                  type: 'warning',
                });
                batchStart = true;
                return ;
              }
            } else {
              if (this.batchNumberList[key].IsTax == 0 && this.batchNumberList[key].IsInTrade == 0
                && this.batchNumberList[key].IsOutTrade == 0) {
                this.$message({
                  message: '请选择货物属性：内贸,外贸,保税！',
                  type: 'warning',
                });
                batchStart = true;
                return ;
              }
              if (this.batchNumberList[key].IsTax == 1 &&
                (this.batchNumberList[key].IsInTrade == 0 && this.batchNumberList[key].IsOutTrade == 0)) {
                this.$message({
                  message: '只有保税不允许保存！',
                  type: 'warning',
                });
                batchStart = true;
                return ;
              }
              if (this.batchNumberList[key].IsTax == 1 && !this.batchNumberList[key].TankID) {
                this.$message({
                  message: '保税货物需要保税罐！',
                  type: 'warning',
                });
                batchStart = true;
                return ;
              }
              if (this.batchNumberList[key].IsInTrade == 1 && this.batchNumberList[key].IsOutTrade == 1) {
                this.$message({
                  message: '内贸外贸不能同时选择',
                  type: 'warning',
                });
                start = true;
                return ;
              }
            }
            for(let j=0;j< this.batchNumberCol.length;j++){
              if (!this.batchNumberCol[j].isNull && !this.batchNumberList[key][this.batchNumberCol[j].field]) {
                if(this.batchNumberCol[j].field==='IsInTrade' ||
                  this.batchNumberCol[j].field==='IsOutTrade' ||
                  this.batchNumberCol[j].field==='IsTax'){
                  if(this.batchNumberList[key].IsInTrade + this.batchNumberList[key].IsOutTrade +this.batchNumberList[key].IsTax < 1){
                    this.$message({
                      message: `${this.batchNumberCol[j].fieldAlias}数据未填写`,
                      type: 'warning',
                    });
                    batchStart = true;
                    return ;
                  }
                }else {
                  this.$message({
                    message: `${this.batchNumberCol[j].fieldAlias}数据未填写`,
                    type: 'warning',
                  });
                  batchStart = true;
                  return ;
                }
              }
            }
          }
          this.batchNumberList[key].ShowIndex = Number(this.batchNumberList[key].ShowIndex);

          this.batchNumberList[key].IsInTrade === null ? this.batchNumberList[key].IsInTrade = 0 : '';
          this.batchNumberList[key].IsOutTrade === null ? this.batchNumberList[key].IsOutTrade = 0 : '';
          this.batchNumberList[key].IsTax === null ? this.batchNumberList[key].IsTax = 0 : '';
          if (!this.batchNumberList[key].updateFlg) this.batchNumberList[key].updateFlg = 'update';
          this.batchNumberList[key].BillID = this.$route.query.id;
          this.batchNumberList[key].ListID = key + 1;
          this.batchNumberList[key].ShowIndex = key + 1;
        }
        if (batchStart) return false;
        this.detailInfo.shipOrderLists = this.batchNumberList;
        this.detailInfo = Object.assign(this.detailInfo, this.formInline);
        this.detailInfo.GoodsName = this.formInline.CEGoodsName;
        this.detailInfo.updateFlg = (this.type === 'edit' || this.type === 'info') ? 'update' : 'add';
        this.detailInfo.IsNon = this.detailInfo.IsNon ? 1 : 0;
       // this.detailInfo.IsWithPail = this.detailInfo.IsWithPail ? 1 : 0;
        this.detailInfo.ExtractSample = this.detailInfo.ExtractSample ? 1 : 0;
        this.detailInfo.NeedAssay = this.detailInfo.NeedAssay ? 1 : 0;
        if (this.type === 'add') {
          this.detailInfo.AccountID = this.userInfor.accountId;
          this.detailInfo.MainOrderID = this.MainOrder;
          this.detailInfo.ServiceID = (this.$route.name === 'billLadingShip' || this.$route.name === 'addBillLadingShip') ? this.shipSID : this.unloadShipSID;
          this.detailInfo.OrderType = this.$route.name === 'addBillLadingShip' || this.$route.name === 'billLadingShip' ? 1 : 0;
          this.detailInfo.State = 0;
          this.detailInfo.IsNon = Number(this.formInline.IsNon);
       //   this.detailInfo.IsWithPail = Number(this.formInline.IsWithPail);

          this.detailInfo.ExtractSample = Number(this.formInline.ExtractSample);
          this.detailInfo.Number = Number(this.formInline.BLNumber);
          this.detailInfo.Unit = 0;
          this.detailInfo.GoodsID = this.formInline.GoodsID;
          this.detailInfo.operatorId = this.userInfor.userName;
          this.detailInfo.CreateDate = dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss');
        }
        this.checkByOrderType();
      },
      saveHttp() {
        console.log(this.detailInfo)
        this.$services.postLoading({
          type: 'BUSINESS',
          url: 'save1',
          params: {
            data: JSON.stringify(this.detailInfo),
          },
        }).then(res => {
          if (res.bean) {
            this.$message({
              message: '保存成功',
              type: 'success',
            });
            this.editStart = true;
            if (this.type === 'add') {
              this.visitedViews.forEach(v => {
                if (v.path === this.$route.path) {
                  v.title = v.title.replace(/新增/, '') + '详情';
                }
              });
            }
            this.type = 'info';
            this.detail(this.id);
            this.$forceUpdate();
            storage.$set({
              key: 'customerServiceTable',
              parameter: true,
            });
            this.$forceUpdate();
          }
        });
      },

      // 数据字典映射，因为计算属性computed不可以动态修改，映射到data数据上
      batchInitCol() {
        this.carOrderBatch.length > 0
        && (this.batchNumberCol = this.carOrderBatch.map(itme => {
            let info = itme;
            info.field = itme.fieldName;
            info.title = itme.fieldAlias;
            info.width = itme.displayWidth;
            info.IsNull = itme.IsNull;
            if (info.fieldName === 'TankID') {
              info.tips = '...';
              info.dialog = 'showTankID';
            }
            return info;
          })
        );
      },
      licenseInitCol() {
        this.carOrderList.length > 0
        && (this.licenseNumberClo = this.carOrderList.map(itme => {
            let info = itme;
            info.field = itme.fieldName;
            info.title = itme.fieldAlias;
            info.width = itme.displayWidth;
            info.IsNull = itme.IsNull;
            return info;
          })
        );
      },
      // 天数关联方法
      inputChangeEven(key) {
        if (key === 'AvailableDays') {
          let newDay = dayjs(this.formInline.BLBeginDate).unix();
          let s = (Number(this.formInline.AvailableDays) - 1) * 86400 + newDay;
          this.formInline.BLEndDate = `${this.$utils.getTimeByDay(dayjs.unix(s).format('YYYY-MM-DD HH:mm:ss'))} ${ this.formInline.BLEndDate.split(' ')[1]}`;
        }
        //当输入的name值变化，清空对应ID
        switch (key) {
          case 'CEGoodsName':
            this.formInline.GoodsID = '';
            break;
          case 'Name':
            this.formInline.GuestID = '';
            break;
          case 'TGuestName':
            this.formInline.TGuestID = '';
            break;
          default:
            break;
        }
      },
      datePickerEven(key) {
        if (key === 'BLBeginDate') {
          let a = this.formInline.BLEndDate.split(' ')[1];
          this.formInline.BLEndDate = `${this.$utils.getTimeByDay(dayjs.unix(dayjs(this.formInline.BLBeginDate).unix() + (86400 * (this.formInline.AvailableDays - 1))).format('YYYY-MM-DD HH:mm:ss'))}`;
          this.formInline.BLEndDate += ' ' + a;
          let futureDay = dayjs(this.formInline.BLEndDate);
          let newDay = dayjs(this.formInline.BLBeginDate);
          this.formInline.AvailableDays = futureDay.diff(newDay, 'day') + 1;
        }
        else if (key === 'BLEndDate') {
          if (dayjs(this.formInline.BLEndDate) < dayjs(this.formInline.BLBeginDate)) {
            this.$message({
              message: '结束日期不可以小于开始日期',
              type: 'error',
            });
            this.formInline.BLEndDate = `${this.$utils.getTimeByDay(dayjs.unix(dayjs(this.formInline.BLBeginDate).unix() + (86400 * (this.formInline.AvailableDays - 1))).format('YYYY-MM-DD HH:mm:ss'))} 23:59:59`;
          }
          let futureDay = dayjs(this.formInline.BLEndDate);
          let newDay = dayjs(this.formInline.BLBeginDate);
          this.formInline.AvailableDays = futureDay.diff(newDay, 'day') + 1;
        }
      },
      clearBatchNumberList() {
        this.batchNumberList.forEach((batchInfo, batchKey) => {
          batchInfo.updateFlg = 'delete';
          this.batchNumberList.splice(batchKey, batchInfo);
        });
      }
    },
    watch: {
      'formInline.BLNumber'(val) {
        if (this.batchFilterData.length === 1) {
          let Index = this.batchNumberList.findIndex(v => v.updateFlg !== 'delete');
          Index > -1 ? this.$set(this.batchNumberList[Index], 'Number', val) : '';
        }
      },
      'formInline.GuestID'(newV, oldV) {
        oldV !== '' ? this.clearBatchNumberList() : '';
      },
      'formInline.GoodsID'(newV, oldV) {
        oldV !== '' ? this.clearBatchNumberList() : '';
      },
      'formInline.BargainID'(newV, oldV) {
        oldV !== '' ? this.clearBatchNumberList() : '';
      },
      'formInline.TGuestID'(newV, oldV) {
        oldV !== '' ? this.clearBatchNumberList() : '';
      },
      carOrderBatch() {
        this.batchInitCol();
      },
      carOrderList() {
        this.licenseInitCol();
      },
      licenseNumberClo() {
        this.$nextTick(() => {
          this.$forceUpdate();
        });
      },
      batchNumberCol() {
        this.$nextTick(() => {
          this.$forceUpdate();
        });
      },
      activeName(val) {
        if (val === '车号信息') {
          this.$nextTick(() => {
            this.$refs.licenseTable.initTable();
          });
        }
        else if (val === '批号信息') {
          this.$nextTick(() => {
            this.$refs.batchTable.initTable();
          });
        }
      },
      '$route.name': function () {
        /*   this.init();
           this.fromList.forEach(itme => {
             this.$set(this.formInline, itme.key, '');
           });*/
      },
      'batchNumberList': function (newVal, oldVal) {
        let start = false
        newVal.forEach(itme => {
          if (itme.updateFlg !== 'delete') start = true;
        });
        if (start && newVal[0]) {
          this.batchNumberListStyle = {
            'minHeight': '200px'
          };
          this.batchNumberListHeight = {
            minHeight: '200px',
            marginBottom: '70px'
          };
        }
        else {
          this.batchNumberListStyle = {
            'minHeight': '100px'
          };
          this.batchNumberListHeight = {
            minHeight: '100px',
            marginBottom: '0px'
          };
        }
        this.$forceUpdate();
      },
      'licenseNumberList': function (newVal, oldVal) {
        let start = false
        newVal.forEach(itme => {
          if (itme.updateFlg !== 'delete') start = true;
        });
        if (start && newVal[0]) {
          this.licenseNumberListStyle = {
            minHeight: '240px'
          };
          this.licenseNumberListHeight = {
            minHeight: '100px',
          };
          if (this.batchNumberList[0]) {
            this.licenseNumberListStyle = {
              minHeight: '200px'
            };
            this.licenseNumberListHeight = {
              minHeight: '100px',
            };
          }
        }
        else {
          this.licenseNumberListStyle = {
            minHeight: '100px'
          };
          this.licenseNumberListHeight = {
            minHeight: '100px',
          };
        }
        this.$forceUpdate();
      }
    },
  };
</script>
<style lang="scss">
  .edit {
    .redTextarea {
      textarea {
        color: red !important;
      }
    }
    .halfItem {
      .el-input--suffix .el-input__inner {
        padding-right: 15px;
        padding-left: 3px;
      }
    }

    .el-upload__input {
      display: none;
    }
    .batchTable {
      .el-table__body-wrapper {
        max-height: 100px !important;
      }
    }
    .edit_modle {
      overflow-y: scroll;
    }
    .el-input-group__append .el-button {
      margin: 0;
    }
    .edit_table {
      width: 100%;
      min-height: 400px;
    }
    .edit_header {
      display: flex;
      .upload-demo {
        margin: 0 10px;
      }
    }
    .el-autocomplete {
      width: 100%;
      input {
        width: 100%;
      }
    }
    .spanEdit {
      height: 34px;
      background: #F5F7FA;
      margin: 0 -3px -7px -3px;
      padding: 4px 10px;
    }
  }

  .customerServiceEdit {
    .edit_table .tableCon .tableContent .tableContent-pane .el-table {
      /*position: static !important;*/
    }
  }
</style>
